import {FunctionComponent, useState} from "react";
import {IUserProfile} from "../../types/UserProfile";
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from "@mui/material";
import {IUserModel} from "../../types/UserModel";
import {Link} from "react-router-dom";
import {Timestamp} from "firebase/firestore";

interface IWithBgcFields {
    candidateId?: string;
    adverseActionDate?: Timestamp;
}

export const UserList: FunctionComponent<{
    users: IUserProfile[] | IUserModel[],
    showName?: boolean,
    to?: string,
    showLoginTime?: boolean,
    showCandidateId?: boolean,
    showAdverseActionDate?: boolean,
}> = ({users, showName, showLoginTime, showCandidateId, showAdverseActionDate, to}) => {
    const pageSize = 25;
    const [page, setPage] = useState(0);

    const sortedUsers = showLoginTime 
        ? [...users].sort((b, a) => {
            const aTime = (a as IUserModel).lastLoginTime?.toDate().getTime() || 0;
            const bTime = (b as IUserModel).lastLoginTime?.toDate().getTime() || 0;
            return bTime - aTime;
        })
        : users;

        return (
        <Box sx={{width: '100%'}}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {showName && <TableCell>Name</TableCell>}
                            <TableCell>User ID</TableCell>
                            {showCandidateId && <TableCell>Candidate ID</TableCell>}
                            {showLoginTime && <TableCell>Last Login Time</TableCell>}
                            {showAdverseActionDate && <TableCell>Waiting Window</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedUsers.slice(page * pageSize, page * pageSize + pageSize).map((row) => (
                            <TableRow
                                component={Link}
                                to={`/${to ?? 'users'}/${row.id}`}
                                key={row.id}
                                role={"link"}
                                hover={true}
                                sx={{'cursor': 'pointer', 'textDecoration': 'none'}}>
                                {showName && <TableCell>{(row as IUserProfile).name}</TableCell>}
                                <TableCell>{row.id}</TableCell>
                                {showCandidateId && (
                                    <TableCell>{(row as IUserModel & IWithBgcFields).candidateId ?? ''}</TableCell>
                                )}
                                {showLoginTime && (
                                    <TableCell>
                                        <span>{(row as IUserModel).lastLoginTime?.toDate().toLocaleString() ?? ''}</span>
                                    </TableCell>
                                )}
                                {showAdverseActionDate && (
                                    <TableCell>
                                        {(row as IUserModel & IWithBgcFields).adverseActionDate?.toDate().toLocaleString() ?? ''}
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component={"div"}
                count={users.length}
                page={page}
                rowsPerPage={pageSize}
                onPageChange={(event, newPage) => setPage(newPage)}/>
        </Box>
    );
}